import type { A2UIComponent, A2UIComponentType } from '@shiftagent/shared';

import { PanelBadge } from './PanelBadge';
import { PanelButton } from './PanelButton';
import { PanelCodeBlock } from './PanelCodeBlock';
import { PanelDataTable } from './PanelDataTable';
import { PanelKPICard } from './PanelKPICard';
import { PanelMarkdown } from './PanelMarkdown';
import { PanelProgressBar } from './PanelProgressBar';

type PanelRenderer = (p: { props: Record<string, unknown> }) => React.ReactNode;

const REGISTRY: Partial<Record<A2UIComponentType, PanelRenderer>> = {
  Markdown: PanelMarkdown,
  DataTable: PanelDataTable,
  CodeBlock: PanelCodeBlock,
  KPICard: PanelKPICard,
  Button: PanelButton,
  Badge: PanelBadge,
  ProgressBar: PanelProgressBar,
};

export function renderPanelComponent(c: A2UIComponent): React.ReactNode {
  const R = REGISTRY[c.type];
  if (!R) {
    return (
      <div
        key={c.id}
        style={{
          padding: 8,
          fontSize: 11,
          color: 'var(--text-mute)',
          fontFamily: 'ui-monospace, SFMono-Regular, monospace',
          background: 'var(--bg-alt2)',
          border: '1px dashed var(--border)',
          borderRadius: 6,
        }}
      >
        Unknown component type: {c.type}
      </div>
    );
  }
  return <R key={c.id} props={c.props as Record<string, unknown>} />;
}
